import { create as e } from "zustand";
import { persist as a, createJSONStorage as t } from "zustand/middleware";
const l = e()(
  a(
    (i) => ({
      isMobileNavigationOpen: !1,
      toggleMobileNavigation: () => i((o) => ({ isMobileNavigationOpen: !o.isMobileNavigationOpen })),
      closeMobileNavigation: () => i({ isMobileNavigationOpen: !1 })
    }),
    {
      name: "mobile-navigation-storage",
      storage: t(() => localStorage)
    }
  )
);
export {
  l as useMobileNavigationStore
};
